import { useState } from "react";

export default function OptionalFields({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ width: "100%", flex: "1 1 100%" }}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          width: "100%",
          padding: "10px 14px",
          border: "1px dashed #d5cdc0",
          borderRadius: "10px",
          backgroundColor: open ? "#fdfbf7" : "transparent",
          color: "#8a7e70",
          fontSize: "13px",
          fontWeight: 500,
          fontFamily: "'DM Sans', sans-serif",
          cursor: "pointer",
          transition: "all 0.2s ease",
        }}
      >
        <span style={{ fontSize: "15px" }}>{open ? "▲" : "▼"}</span>
        Date adiționale (opțional)
      </button>
      {open && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", marginTop: "12px" }}>
          {children}
        </div>
      )}
    </div>
  );
}
